import api from '../apiClient';
import i18n from '../../i18n';

export const askLuna = async (message, currentPath, conversationId = null) => {
  const url = '/luna';
  // Send the active UI language so Luna replies in it (not the language she
  // detects from the typed message). Normalize 'en-US' → 'en'.
  const language = (i18n.language || 'en').split('-')[0];
  const payload = { message, currentPath, language };
  if (conversationId) {
    payload.conversationId = conversationId;
  }

  console.log('[luna API] Sending request:', {
    url: `${process.env.REACT_APP_SERVER_URL}${url}`,
    method: 'POST',
    payload: { message, currentPath, conversationId },
    hasToken: !!localStorage.getItem('token'),
  });

  try {
    const response = await api.post(url, payload);

    console.log('[luna API] Response received:', {
      status: response?.status,
      success: response?.data?.success,
      hasData: !!response?.data?.data,
      replyLength: response?.data?.data?.reply?.length,
      navigateTo: response?.data?.data?.navigateTo,
    });

    return response;
  } catch (error) {
    console.error('[luna API] Error:', {
      message: error?.message,
      status: error?.response?.status,
      statusText: error?.response?.statusText,
      data: error?.response?.data,
      url: error?.config?.url,
    });
    throw error;
  }
};

export const saveLunaMessage = async (message, currentPath, role = 'user', conversationId = null) => {
  const url = '/luna/message';
  const payload = { message, currentPath, role };
  if (conversationId) {
    payload.conversationId = conversationId;
  }

  console.log('[luna API] Saving message:', {
    url: `${process.env.REACT_APP_SERVER_URL}${url}`,
    method: 'POST',
    payload: { message, currentPath, conversationId },
    hasToken: !!localStorage.getItem('token'),
  });

  try {
    const response = await api.post(url, payload);

    console.log('[luna API] Message saved:', {
      status: response?.status,
      success: response?.data?.success,
    });

    return response;
  } catch (error) {
    console.error('[luna API] Error saving message:', {
      message: error?.message,
      status: error?.response?.status,
      statusText: error?.response?.statusText,
      data: error?.response?.data,
      url: error?.config?.url,
    });
    throw error;
  }
};

export const getLunaMessages = async (limit = 50) => {
  const url = `/luna/messages?limit=${limit}`;
  
  console.log('[luna API] Fetching messages:', {
    url: `${process.env.REACT_APP_SERVER_URL}${url}`,
    method: 'GET',
    hasToken: !!localStorage.getItem('token'),
  });

  try {
    const response = await api.get(url);
    
    console.log('[luna API] Messages received:', {
      status: response?.status,
      success: response?.data?.success,
      messagesCount: response?.data?.data?.length || 0,
    });
    
    return response;
  } catch (error) {
    console.error('[luna API] Error fetching messages:', {
      message: error?.message,
      status: error?.response?.status,
      statusText: error?.response?.statusText,
      data: error?.response?.data,
      url: error?.config?.url,
    });
    throw error;
  }
};

// ============================================
// CONVERSATION API FUNCTIONS
// ============================================

export const createLunaConversation = async (title = null) => {
  const url = '/luna/conversations';
  const payload = title ? { title } : {};

  console.log('[luna API] Creating conversation:', { title });

  try {
    const response = await api.post(url, payload);
    console.log('[luna API] Conversation created:', response?.data?.data?._id);
    return response;
  } catch (error) {
    console.error('[luna API] Error creating conversation:', error?.message);
    throw error;
  }
};

export const getLunaConversations = async (limit = 20, skip = 0) => {
  const url = `/luna/conversations?limit=${limit}&skip=${skip}`;

  console.log('[luna API] Fetching conversations:', { limit, skip });

  try {
    const response = await api.get(url);
    console.log('[luna API] Conversations received:', response?.data?.data?.length || 0);
    return response;
  } catch (error) {
    console.error('[luna API] Error fetching conversations:', error?.message);
    throw error;
  }
};

export const getLunaConversation = async (conversationId, messageLimit = 100) => {
  const url = `/luna/conversations/${conversationId}?messageLimit=${messageLimit}`;

  console.log('[luna API] Fetching conversation:', conversationId);

  try {
    const response = await api.get(url);
    console.log('[luna API] Conversation received with messages:', response?.data?.data?.messages?.length || 0);
    return response;
  } catch (error) {
    console.error('[luna API] Error fetching conversation:', error?.message);
    throw error;
  }
};

export const updateLunaConversation = async (conversationId, title) => {
  const url = `/luna/conversations/${conversationId}`;
  const payload = { title };

  console.log('[luna API] Updating conversation:', { conversationId, title });

  try {
    const response = await api.patch(url, payload);
    console.log('[luna API] Conversation updated:', conversationId);
    return response;
  } catch (error) {
    console.error('[luna API] Error updating conversation:', error?.message);
    throw error;
  }
};

export const deleteLunaConversation = async (conversationId) => {
  const url = `/luna/conversations/${conversationId}`;

  console.log('[luna API] Deleting conversation:', conversationId);

  try {
    const response = await api.delete(url);
    console.log('[luna API] Conversation deleted:', conversationId);
    return response;
  } catch (error) {
    console.error('[luna API] Error deleting conversation:', error?.message);
    throw error;
  }
};

